import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { MobileVillageListPageContainer, VillageListPageContainer } from '../VillageListPage';
import { TReduxStore } from '../../types/store';
import { AppContext } from './AppContext';
import { IApplicationContext } from '../../types/application';
import * as styles from './App.css';
import { HelmetContainer } from '../HelmetContainer';
import { LocationDetectModalContainer } from '../LocationDetectModalModalContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export class Application extends React.Component<IApplicationProps> {
  public render() {
    const { context, reduxStore } = this.props;
    const {
      mobile: { isMobileVersion },
    } = reduxStore.getState();

    return (
      <Provider store={reduxStore}>
        {/* Вне boundary: при ошибке рендера страницы Helmet не размонтируется и не удалит FAQPage из head */}
        <HelmetContainer />
        <ErrorLogComponent logger={context.logger}>
          <AppContext.Provider value={context}>
            <div className={styles['index']}>
              <MicrofrontendProvider registry={context.microfrontendsRegistry}>
                {isMobileVersion ? <MobileVillageListPageContainer /> : <VillageListPageContainer />}
                <LocationDetectModalContainer />
              </MicrofrontendProvider>
            </div>
          </AppContext.Provider>
        </ErrorLogComponent>
      </Provider>
    );
  }
}
